import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { BaseCustomerUsersGuard } from './_guards/base-customer-users.guard';
import { BaseRequirementListGuard } from './_guards/base-requirement-list.guard';
import { baseCustomerDepartmentEffects, baseCustomerDepartmentReducer } from '../../_store';
import { BaseCustomerDepartmentService } from './base-customer-department.service';

@NgModule({
  imports: [
    StoreModule.forFeature('customerDepartment', baseCustomerDepartmentReducer.BaseCustomerDepartmentReducer),
    EffectsModule.forFeature([baseCustomerDepartmentEffects.BaseCustomerDepartmentEffects]),
  ],
  declarations: [],
  exports: [],
  providers: [BaseCustomerDepartmentService, BaseCustomerUsersGuard, BaseRequirementListGuard],
})
export class BaseCustomerDepartmentModule {}
